import React from 'react';
import { FormErrorMessage } from '@chakra-ui/react';
import { flattenObjectValuesToArray } from '../../../services/errors/formErrors';
const FormFieldErrors = ({ errors }) => {
    if (!errors)
        return;
    const errorList = typeof errors === 'string' ? [errors] : flattenObjectValuesToArray(errors);
    return (React.createElement(React.Fragment, null, errorList.map((error) => (React.createElement(FormErrorMessage, { "data-testid": "form_field_error_message", key: error }, error)))));
};
export default FormFieldErrors;
